import store from '@/store/index'
import { getListToFirst } from './orderFetch'
import { computed, reactive, watch, ref, onMounted, nextTick } from 'vue'
import { debounce } from '@/utils/index'
import { get } from 'lodash'
import { unreadCount, setMsgListFromStorage, setStoreChatMsgList } from '@/utils/unReadNum'
import { queryEncouragement } from '@/api/workPlace/encourage'
import { computeGroupId } from '@/views/WorkPlace/components/WorkOrder/components/hooks/useGroupOrder.js'

const OUTSIDE_SIDE_ORDER = reactive({
  // 查询工单条件  1：医生/患者姓名 2：工单ID
  searchType: 1,
  name: undefined, // 医生/患者名称/id
  // suspendFlag: false, //搜索挂起工单
  lastList: [], // 暂存一下上次的请求结果
  lastProcessList: [], // 处理中工单原始列表
  // 当前渲染的工单列表
  list: [],
  manualSuspendFlag: false, //搜索手动挂起工单
  autoSuspendFlag: false, //搜索自动挂起工单
  rollBackSort: false, // 搜索临回滚工单
  realTimeFlag: undefined, // 搜索即时工单
  realTimeOrder: null,
  realTimeOrderList: [
    {
      value: 10,
      label: '导诊咨询'
    },
    {
      value: 39,
      label: '需求跟踪'
    },
    {
      value: 5,
      label: '处方待购'
    },
    {
      value: 1,
      label: '私聊工单'
    },
    {
      value: 22,
      label: '复诊跟踪'
    },
    // {
    //   value: 24,
    //   label: '复诊日期-不同意'
    // },
    {
      value: 25,
      label: '复诊日期-未确认'
    },
    {
      value: 26,
      label: '填写诊断及复诊日期'
    },
    {
      value: 33,
      label: '复诊提醒'
    },
    {
      value: 32,
      label: '疗效跟踪'
    },
    {
      value: 38,
      label: '疗效反馈'
    }
  ],
  hanupType: null, //挂起工单的类型
  // 待处理工单列表
  pendList: {},
  // 处理中工单列表
  processList: [],
  autoNum: 0,
  manualNum: 0,
  //最大限制表单挂起数量
  workOrderSuspendNumberLimit: 0,
  // 当前工单属于（ 2-待处理；3-处理中）
  activeKey: 2
})
const OUT_SIDE_BENCH = reactive({
  // tab页面
  tabs: [
    {
      // 待处理工单数
      label: '待处理',
      count: 0,
      key: 2,
      dot: false,
      zMsgCount: 0
    },
    {
      // 处理中工单数
      label: '处理中',
      count: 0,
      key: 3,
      dot: false,
      zMsgCount: 0 // 消息未读数
    }
  ],
  // 只有处理中的需要选中背景
  isCheckTab: false,
  loading: false
})
const OUT_SIDE_GUIDECONSULTLIST = ref([])

const OUT_SIDE_GUIDECONSULTISD = ref([])
// 导出主要函数部分
export default function () {
  // 所有的消息会话
  const group = computed(() => store.state.chat.msgList.group)
  const erpId = computed(() => store.getters.userInfo.erpId)
  // ref 获取元素监听滚动条
  const orderDOM = ref(null)
  // 工单 取消闭包否则无法关联修改
  const orders = OUTSIDE_SIDE_ORDER
  const bench = OUT_SIDE_BENCH
  // 默认的置顶工单（导诊、代购工单）
  const guideConsultList = OUT_SIDE_GUIDECONSULTLIST
  const guideConsultIds = OUT_SIDE_GUIDECONSULTISD
  // 置顶和置底
  const fastTrack = reactive({
    up: {
      src: require('@/assets/img/work-place/up.png'),
      visible: false
    },
    down: {
      src: require('@/assets/img/work-place/down.png'),
      visible: false
    }
  })
  // 初始化是判断群组有没有缓存信息，如果有就把缓存里的信息同步到store.chat.msgList
  onMounted(() => {
    setMsgListFromStorage()
  })

  // 监听消息组
  watch(
    group,
    newGroup => {
      newGroup
      // 处理中工单 有多少条未读
      const count = unreadCount(newGroup)
      setTimeout(() => {
        // 更新缓存数据
        setStoreChatMsgList({ group: newGroup }, 'noUpDate')
      }, 0)
      bench.tabs[1].zMsgCount = count || 0
      // 待处理没有获取到对应的 orders.list
      if (orders.activeKey === 3) {
        orders.processList = updateChatList(newGroup, orders.processList)
        // 置顶的工单要根据消息发送时间重新排序
        toppingList.value = updateChatList(newGroup, toppingList.value)
        guideConsultList.value = updateChatList(newGroup, guideConsultList.value)
      }
    },
    { deep: true }
  )
  //更新处理中会话
  const updateChatList = (chat, list = []) => {
    list.forEach(item => {
      //三方群聊消息
      const groupList = chat[item.groupId] || []
      //私聊群消息
      const privateList = chat[item.assistantPatientGroupId] || []
      // 导诊咨询群消息
      const guideConsultList = chat[item.guideConsultGroupId] || []
      // 医生私聊群
      const doctorDaGroupList = chat[item.doctorDaGroupId] || []
      let chatList = []
      //私聊群只统计对应私聊群消息未读数量，三方群如果包含私聊群需要一起统计
      switch (item.groupType) {
        case 2:
          chatList = privateList
          break
        case 3:
          chatList = [...guideConsultList, ...privateList, ...groupList, ...doctorDaGroupList]
          break
        case 4:
          chatList = doctorDaGroupList
          break
        case 0:
          chatList = [...privateList, ...groupList, ...doctorDaGroupList]
          break
      }
      // 未读数量计算
      const unread =
        chatList
          // ai 工单免打扰
          .filter(el => el.customEvent !== '50800')
          .filter(el => el.status === 'unread' && el.customEvent !== '23009').length || 0 // 23009-单病种随访问卷 免打扰
      item.msgCount = unread
      //会话列表取最后一条消息
      try {
        chatList = chatList.sort((a, b) => {
          return (a.timestamp || a.time) - (b.timestamp || b.time)
        })
        item.chatRecord = chatList[chatList.length - 1] || item.chatRecord
      } catch {
        item.chatRecord = chatList[chatList.length - 1] || item.chatRecord
      }
    })
    //按时间倒序
    return handleChatSort(list)
  }
  function changeToProcess() {
    orders.activeKey = 3
    nextTick(() => {
      onResetFetch()
    })
  }

  // FIXME:重置查询工作台工单条件
  function onResetFetch() {
    // NOTE:待处理工单需要滚动条置顶
    if (orders.activeKey === 2) {
      orderDOM.value && (orderDOM.value.scrollTop = 0)
      fastTrack.up.visible = false
      fastTrack.down.visible = false
    }
    getOrders()
  }
  // 获取列表
  const getOrders = debounce(function () {
    bench.loading = true
    toppingList.value = []
    guideConsultList.value = []
    // FIXME:会出现头像不一致问题
    orders.pendList = []
    orders.processList = []
    // 滚动时候记录一下当前的滚动高度
    getListToFirst(store, orders, bench)
      .then(({ pendList, processList }) => {
        orders.pendList = pendList
        // 2-待处理；3-处理中
        if (orders.activeKey === 3) {
          resortProcessingList(processList)
        } else {
          isNeedEncourage(pendList)
        }
      })
      .finally(() => {
        bench.loading = false
      })
  })

  // 处理中工单排序处理集合
  const resortProcessingList = processList => {
    let _processList = processList.map(v => ({ ...v, msgCount: 0 }))
    orders.rollBackSort && (_processList = _processList.filter(rollbackFilter))
    orders.manualSuspendFlag &&
      (_processList = _processList.filter(item => item.suspendManualNumber))
    orders.autoSuspendFlag && (_processList = _processList.filter(item => item.suspendAutoNumber))
    orders.realTimeFlag &&
      (_processList = _processList.filter(item =>
        item.businessTypeList.includes(orders.realTimeFlag)
      ))
    orders.processList = updateChatList(group.value, _processList)
    console.log('orders.processList', orders.processList)
    handleResortList()
    handleGuideConsultList()
  }
  const showEncourage = ref(false)
  const workStatus = computed(() => store.getters.workStatus)

  const isNeedEncourage = async list => {
    const { pendingWorkOrder, waitingForAllotWorkOrderList: waitList } = list
    const workOrderId = get(pendingWorkOrder, 'workOrderId', null)
    const leng = get(waitList, 'length', 0)
    const isEncouragement = await queryEncouragement()
    if (!workOrderId && !leng && workStatus.value === 0 && isEncouragement) {
      showEncourage.value = true
    }
  }
  // 处理置顶按钮的显示和隐藏
  function scrollBottom({ target }) {
    const DOM = target
    const scrollHeight = DOM.scrollHeight,
      scrollTop = DOM.scrollTop,
      height = DOM.offsetHeight

    const scrollBottom = scrollHeight - scrollTop - height
    fastTrack.up.visible = scrollTop > 100
    fastTrack.down.visible = scrollBottom > 100
  }
  const curTopList = ref([]) // 当前erp对应的置顶工单数组
  const toppingList = ref([]) // 置顶的工单对象（手动置顶）
  // 置顶处理中的工单,obj是当前要置顶的对象
  function handleTop(params, add) {
    if (add) {
      toppingList.value.unshift(params)
    } else {
      toppingList.value = toppingList.value.filter(it => it.groupId !== params.groupId)
    }
    const obj = JSON.parse(localStorage.getItem('TOP_LIST')) || {}
    curTopList.value = obj[erpId.value] || []
    // toppingList.value = handleChatSort(toppingList.value)
  }
  // 工单置顶(引导工单-自动置顶)
  //  置顶完成后需要调整 WorkOrder/index.vue中的 showOrder 函数
  const handleGuideConsultList = () => {
    const { processList = [] } = orders
    const realTimeOrderList = OUTSIDE_SIDE_ORDER.realTimeOrderList.map(v => v.value)
    try {
      // 导诊工单 和 代购买工单置顶
      const ls = processList.filter(it => {
        const hasRealTimeOrder = realTimeOrderList.some(v => it.businessTypeList.includes(v))
        if (it.guideConsultGroupId || hasRealTimeOrder) {
          return true
        } else {
          return false
        }
      })
      guideConsultList.value = handleChatSort(ls.filter(it => it))
      guideConsultIds.value = ls.map(it => it.guideConsultGroupId)
    } catch {
      guideConsultList.value = []
      guideConsultIds.value = []
    }
    nextTick(() => {
      fastTrack.up.visible = false
      fastTrack.down.visible = false
    })
  }
  const handleResortList = () => {
    const obj = JSON.parse(localStorage.getItem('TOP_LIST')) || {}
    const list = obj[erpId.value] || []
    curTopList.value = list
    try {
      const ls = list.map(item => {
        const obj = orders.processList.find(
          it => it.groupId === item || (!it.groupId && it.doctorDaGroupId === item)
        )
        return obj
      })
      toppingList.value = handleChatSort(ls.filter(it => it))
    } catch {
      toppingList.value = []
    }
    // console.log(11111, orders.processList)
  }
  const handleChatSort = list => {
    try {
      return list.sort(({ chatRecord: a }, { chatRecord: b }) => {
        return (b.timestamp || b.time) - (a.timestamp || a.time)
      })
    } catch {
      return list
    }
  }
  // 搜索挂起的工单
  const searchHangupOrder = (flag, hanupType) => {
    orders.rollBackSort = false
    orders.realTimeOrder = null
    orders.realTimeFlag = false

    if (orders.hanupType !== hanupType) {
      orders.manualSuspendFlag = false
      orders.autoSuspendFlag = false
    }
    hanupType === 0 ? (orders.manualSuspendFlag = flag) : (orders.autoSuspendFlag = flag)
    orders.hanupType = hanupType
    if (flag) {
      if (hanupType) {
        orders.processList = orders.lastProcessList.filter(item => item.suspendAutoNumber)
      } else {
        orders.processList = orders.lastProcessList.filter(item => item.suspendManualNumber)
      }
    } else {
      orders.processList = orders.lastProcessList
    }
    handleResortList()
    handleGuideConsultList()
  }
  // 刷新工单list
  const refreshOrderList = () => {
    onResetFetch()
  }

  // 搜索临回滚工单
  function rollbackFilter(item) {
    const { guideConsultGroupId, groupId, doctorDaGroupId, assistantPatientGroupId, groupType } =
      item
    const keyId = computeGroupId(
      guideConsultGroupId,
      groupId,
      doctorDaGroupId,
      assistantPatientGroupId,
      groupType
    )
    const rollBackInstance = computed(() => store.state.rollBack.roundInstance)
    const rollBackSplit = computed(() => store.state.rollBack.rollBackSplit)
    const isInclude = rollBackInstance.value.has(keyId)
    return isInclude && rollBackInstance.value.get(keyId)?.countdown <= rollBackSplit.value
  }

  const searchCloseToRoll = isSort => {
    orders.rollBackSort = isSort
    orders.manualSuspendFlag = false
    orders.autoSuspendFlag = false
    orders.realTimeOrder = null
    orders.realTimeFlag = false

    if (isSort) {
      orders.processList = orders.lastProcessList.filter(rollbackFilter)
    } else {
      orders.processList = [...orders.lastProcessList]
    }
    handleResortList()
    handleGuideConsultList()
  }

  const handleChangeRealTimeOrder = e => {
    // e是这个枚举 realTimeOrderList
    console.log('e', e)
    orders.realTimeFlag = e
    if (e) {
      orders.manualSuspendFlag = false
      orders.autoSuspendFlag = false
      orders.rollBackSort = false
      orders.processList = orders.lastProcessList.filter(item =>
        (item.businessTypeList || []).includes(e)
      )
    } else {
      orders.processList = [...orders.lastProcessList]
    }
    handleResortList()
    handleGuideConsultList()
  }
  // 初始化筛选列表
  const initSortStatus = () => {
    orders.manualSuspendFlag = false
    orders.autoSuspendFlag = false
    orders.rollBackSort = false
    orders.realTimeFlag = undefined
    orders.realTimeOrder = null
    orders.searchType = 1
    orders.name = undefined
  }
  return {
    orders,
    bench,
    getOrders,
    scrollBottom,
    onResetFetch,
    handleTop,
    toppingList,
    curTopList,
    erpId,
    guideConsultList,
    guideConsultIds,
    fastTrack,
    showEncourage,
    orderDOM,
    searchHangupOrder,
    refreshOrderList,
    searchCloseToRoll,
    handleChangeRealTimeOrder,
    changeToProcess,
    initSortStatus
  }
}
